<div #chartContainer style="text-align: center; height: 100%; min-height: 250px;" id="chart-container'">
  <google-chart
    #chart
    style="width: 98%; margin: 0px auto; border-radius: 5px;"
    [type]="changingChart.type"
    [data]="changingChart.data"
    [columns]="changingChart.columns"
    [options]="chartOptions"
    [height]="chartHeight"
    (ready)="onChartReady(chartContainer)"
  >
  </google-chart>
<p class="chart-def">
  <span>
    <ion-icon name="ellipse" style="color: #7D7A7A"></ion-icon>&nbsp;
    Shift
  </span>
  <span>
    <ion-icon name="ellipse" style="color: #4caf50"></ion-icon>&nbsp;
    Inside
  </span>
  <span>
    <ion-icon name="ellipse"  style="color: #f44336"></ion-icon>&nbsp;
    Outside
  </span>
</p>
</div>
